import { GridLines as VisxGridLines } from '@visx/grid/lib/types';

import { GridLine } from './GridLine.js';

export type GridLinesProps = {
  lines: VisxGridLines;
  highlightAccessor?: (
    from: { x?: number; y?: number },
    to: { x?: number; y?: number },
  ) => boolean;
};

export const GridLines = ({
  lines,
  highlightAccessor = () => false,
}: GridLinesProps) => (
  <>
    {lines.map(({ from, to, index }) => (
      <GridLine
        key={`grid-line-${index}`}
        from={from}
        to={to}
        highlight={highlightAccessor(from, to)}
      />
    ))}
  </>
);
